import React, { Fragment, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router'

import AppContext from '../context';
import VMContext from './context';
import { LOOKS_TAB, MAKEUP_TAB, language, LANG_JP, LANG_KR, LANG_SG, LANG_MY, pageDefaultTitle, LANG_RU, LANG_ARABIA_EN, LANG_ARABIA, LANG_ID } from 'Root/constants';

import { AlertMessage } from '../commonComponents';
import { ConfirmationModal } from '../modal';
import { isIFRAMEUrl, defineFilter } from 'Root/utils';
import Tutorial from './Tutorial';
import ProductsTab from './ProductsTab';
import BuyProductButton from './BuyProductButton';
import Perfectcorp from './Perfectcorp';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import content from 'Content/content.json';
import './VirtualMirror.scss';
import CookiePolicyVM from 'Components/cookiePolicy/cookiePolicyVM';
import { imageSet } from 'Components/helper/Images';
import queryString from 'query-string';

const VirtualMirror = (props) => {
  const lensType = Object.keys(content.data.productInfo[language]);

  const appContext = useContext(AppContext);
  const vmContext = useContext(VMContext);
  const { selectedTab } = vmContext;
  const { close } = props;
  const SHOW_COOKIE_POLICY = process.env.REACT_APP_SHOW_COOKIE_POLICY || 'no';

  useEffect(() => {
    if (language === LANG_JP) {
      document.title = pageDefaultTitle + "|vm";
      return () => {
        document.title = pageDefaultTitle;
      }
    }
  });

  const {
    location,
    match: {
      params: { result: quizMultiResult },
    },
  } = props;

  useEffect(() => {
    const previousPath = location.state && location.state.from;

    if (previousPath !== 'quiz') {
      appContext.updateProduct(0, 1);
      appContext.updateRecommendation(-1, -1);
    }

    if (quizMultiResult) {
      const splitResult = quizMultiResult.split('_');
      if (splitResult[2]) {
        vmContext.setVmState({ selectedTab: lensType[splitResult[2]], selectedLensType: lensType[splitResult[2]], recommendedLensType: lensType[splitResult[2]] });
      }
      appContext.updateRecommendation(
        parseInt(splitResult[0]),
        parseInt(splitResult[1])
      );
    }

    return () => {
      appContext.updateProduct(0, 1);
      appContext.updateClearLens(false);
      appContext.updateClearLooks(false);
      appContext.updateMakeupCleared(false);
      appContext.updateForceLookReset(false);
      appContext.updateForceMakeupReset(false);
      !vmContext.setVmState.loader && window.YMK && window.YMK.close();
      language === LANG_JP && appContext.updateRecommendation(-1, -1);
    };
  }, []);
  useEffect(() => {
    if (close) {
      vmContext.resetVM();
    }
  }, [close]);

  const closeRemovalPopUp = () => {
    vmContext.setVmState({ showLookRemovalPopUp: false });
    document.body.classList.remove('open');
  };

  const confirmedRemoval = (type) => {
    //If looks tab is selected then lookRemoval will be true
    const lookRemoval = type === LOOKS_TAB;
    vmContext.setVmState({ selectedTab: lookRemoval ? MAKEUP_TAB : LOOKS_TAB });
    if (lookRemoval) {
      vmContext.removeAppliedLook();
    } else {
      vmContext.removeAppliedMakeup();
    }
    vmContext.setVmState({ showLookRemovalPopUp: false });
    document.body.classList.remove('open');
  };

  const splitResult = quizMultiResult ? quizMultiResult.split('_') : false;
  const defaultLensType = quizMultiResult ? splitResult[2]:0;
  const defaultLensID = quizMultiResult ? splitResult[0]:0;
  const {
    data: {
      productInfo: {
        [language]: { [lensType[defaultLensType]]: lensList },
      },
    },
  } = content;
  const { lensCleared, InstagramBackgroundURL } = appContext;
  const values = queryString.parse(window.location.search);
  const [nextLensID, setNextLensID] = useState(defaultLensID);
  const [nextFilterID, setNextFilterID] = useState(parseInt(values.filter));

  const switchFilterURL = () => {
    var next_lens_id1 = nextLensID;
    if (quizMultiResult) {
      if (nextLensID == content.data.productInfo[language][lensType[splitResult[2]]].length-1) {
        next_lens_id1 = 0;
        setNextLensID(next_lens_id1);
      } else {
        ++next_lens_id1;
        setNextLensID(next_lens_id1);
      }
      const item = lensList[next_lens_id1];
      appContext.updateLensGuid(item.guid, item.key);
      appContext.updateProduct(next_lens_id1, item.id);
      appContext.updateClearLens(false);
      vmContext.handleLensChange(next_lens_id1, 1, selectedTab);
      appContext.updateInstagramBackgroundURL(isIFRAMEUrl() && defineFilter() ? content.data.productInfo[language][selectedLensType][next_lens_id1]['instagram'][defineFilter()]  : '');
    }
  }

  const switchFilterURL2 = () => {
    var next_filter_id = nextFilterID;
    if (quizMultiResult) {
      if(next_filter_id == Object.keys(content.data.productInfo[language][selectedLensType][nextLensID]['instagram']).length) {
        next_filter_id = 1;
        setNextFilterID(next_filter_id);
      } else {
        next_filter_id = next_filter_id + 1;
        setNextFilterID(next_filter_id);
      }
      appContext.updateInstagramBackgroundURL(isIFRAMEUrl() && defineFilter() ? content.data.productInfo[language][selectedLensType][nextLensID]['instagram']["filter"+next_filter_id] : '');
    }
  }
  
  let { result, recommendation } = props.match.params;
  recommendation = result ? result.split('_')[0] : recommendation;
  recommendation = parseInt(recommendation);

  const { showLookRemovalPopUp, actionWillRemove, selectedLensType, lensIndex } = vmContext;

  return (
    <Fragment>
      <section className="content--component__vm" style={(isIFRAMEUrl() && defineFilter())? {backgroundImage: 'url(' + imageSet[InstagramBackgroundURL] + ')'}:{}}>
        {(language === LANG_KR || language === LANG_SG || language === LANG_MY || language === LANG_RU || language === LANG_ARABIA_EN || language === LANG_ARABIA || language === LANG_ID) && (
          <section className="content--component__browser-alert">
            <FormattedHTMLMessage id="product.browser-alert" defaultMessage="Internet Explorper is not supported" />
          </section>
        )}
        { SHOW_COOKIE_POLICY === 'yes' && isIFRAMEUrl() && (
          <CookiePolicyVM/>
        )}
        <section className="content--component__ymk-module">
          <Perfectcorp recommendation={recommendation} />
        </section>
        {/** --------------Lens and makeup Items---------------- */}
        <section className="content--component__header">
          {language === LANG_JP &&
            lensCleared && ( // Not clear why Alert is seperatly shown for Japan with same props ??
              <AlertMessage
                id="tabs.pls_select_lens"
                defaultMessage="Please select a lens"
              />
            )}
          <ProductsTab recommendation={recommendation} />
        </section>
        {/* --------------- Lens Tutorial-----------------*/}
        <BuyProductButton />
        <Tutorial />
        {(isIFRAMEUrl() && defineFilter() ) && (
          <Fragment>
            <Fragment>
              <div className="refresh-lens-wrapper" onClick={switchFilterURL}>
                <img src={imageSet['instagram_refresh_lens']}/>
              </div>
            </Fragment>
            <Fragment>
              <div className="refresh-effect-wrapper" onClick={switchFilterURL2}>
                  <img src={imageSet['instagram_refresh_effect']}/>
              </div>
            </Fragment>
        </Fragment>
        )}
      </section>

      {/* ------------------Tab Switch Confirmation -------------- */}

      {showLookRemovalPopUp && (
        <ConfirmationModal
          allow={() =>
            confirmedRemoval(actionWillRemove === 'looks' ? 'looks' : 'makeup')
          }
          notAllow={closeRemovalPopUp}
          modalType="removal"
          actionWillRemove={actionWillRemove}
        />
      )}
    </Fragment>
  );
};

export default withRouter(VirtualMirror);
